import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService, VerifyAccountDTO } from 'synergy-core';

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.sass']
})
export class VerifyAccountComponent {

  activationKey!: string;
  verifyAccount!: VerifyAccountDTO;
  constructor(
    private userAccountService: UserService,
    private route: ActivatedRoute) { }



    ngOnInit() {
      this.activationKey = this.route.snapshot.paramMap.get("activationKey")!;
      this.verifyAccount = new VerifyAccountDTO();
      this.verifyAccount.activationKey  = this.activationKey;
      this.userAccountService.VerifyAccount(this.verifyAccount).subscribe((data) => {
      });
    }
}
